import { Component, EventEmitter, Input, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { AssessmentInfoViewModel } from 'app/assessment/AssessmentInfoViewModel';
import { ToastrService } from 'core/toastr.service';

import { CreateAssessmentGQL, EntityWithAssessments } from 'generated/graphql';

/**
 * Will update the assessment for an entity in the database
 * when a button is clicked.
 *
 * saved event emits updated entity record.
 */
@Component({
  selector: 'app-entity-assessment-add',
  template: `
    <app-assessment-buttons [horizontal]="horizontal" [entityTypeId]="entityTypeId" (selected)="onAssessmentSelected($event)" class="row tc">
    </app-assessment-buttons>
  `
})
export class EntityAssessmentAddComponent {
  isSaving = false;

  /** Entity Id */
  @Input() entityId: string;
  /** Campaign Id */
  @Input() campaignId: string;

  @Input() entityTypeId: string;

  /** Layout of buttons (default vertical) */
  @Input() horizontal: boolean;

  @Output() saved = new EventEmitter<EntityWithAssessments.Fragment>();

  constructor(
    private createAssessmentGQL: CreateAssessmentGQL,
    private toastrService: ToastrService) {
  }

  onAssessmentSelected(ai: AssessmentInfoViewModel) {
    this.createAssessment(ai);
  }

  createAssessment(ai: AssessmentInfoViewModel) {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    const input = {
      campaignId: this.campaignId,
      entityId: this.entityId,
      assessments: [{
        level: ai.level,
        notes: null
      }]
    };
    this.createAssessmentGQL.mutate({ input })
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe(
        ({ data }) => {
          this.saved.emit(data.createAssessments.entity);
          this.toastrService.success('Assessment Updated');
        },
        (err) => {
          this.toastrService.error('Assessment failed to update.');
          console.error(err);
        });
  }
}
